import Vue from "vue";
import Router from "vue-router";
import ProductOverviewPage from "../views/ProductOverviewPage";
import ProductPage from "../views/ProductPage.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "",
  routes: [
    {
      // product overzicht pagina
      path: process.env.NODE_ENV === "development" ? "/products/" : "",
      name: "ProductOverviewPage",
      component: ProductOverviewPage,
    },

    {
      // product detail pagina
      path: process.env.NODE_ENV === "development" ? "/:culture/:products/:urlSegment" : "",
      name: "WonenObject",
      component: ProductPage,
    },
  ],

  // https://router.vuejs.org/guide/advanced/scroll-behavior.html#async-scrolling
  scrollBehavior() {
    // return desired position
    return { x: 0, y: 0 };
  },
});
